import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import ExternalToolsPage from "@/pages/admin/ExternalToolsPage";

export const Route = createFileRoute("/_admin/admin/external-tools")({
  head: () => pageHead("Admin · External Tools", "AKIVA admin · external tools portal.", "/admin/external-tools", true),
  component: ExternalToolsPage,
});
